var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWavedown2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 1700 120",
    width: 1700,
    height: 120,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 76L35.5 68.2C71 60.3 142 44.7 212.8 45.3C283.7 46 354.3 63 425.2 64C496 65 567 50 637.8 51.3C708.7 52.7 779.3 70.3 850.2 74.5C921 78.7 992 69.3 1062.8 57.7C1133.7 46 1204.3 32 1275.2 32.5C1346 33 1417 48 1487.8 57.3C1558.7 66.7 1629.3 70.3 1664.7 72.2L1700 74L1700 121L1664.7 121C1629.3 121 1558.7 121 1487.8 121C1417 121 1346 121 1275.2 121C1204.3 121 1133.7 121 1062.8 121C992 121 921 121 850.2 121C779.3 121 708.7 121 637.8 121C567 121 496 121 425.2 121C354.3 121 283.7 121 212.8 121C142 121 71 121 35.5 121L0 121Z",
    fill: "#000532",
    strokeLinecap: "round",
    strokeLinejoin: "miter"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWavedown2);
export default __webpack_public_path__ + "static/media/wavedown2.312f23f35ceb42dac77a746d0bfc243b.svg";
export { ForwardRef as ReactComponent };